import CardsRender from './CardsRender';
import withInfiniteScroll from '../../../../HOC/withInfiniteScroll';

export default withInfiniteScroll(CardsRender);
